module.exports = __webpack_public_path__ + "img/扶梯2.430b182d.png";